import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @fragment RefusalReasonFragment
 * @since 1.0.0
 */
export const RefusalReasonFragment = gql `
  fragment RefusalReasonFragment on RefusalReason {
    id
    title
    createdAt
    updatedAt

    translations {
      id
      title
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }
  }
  ${LanguageFragment}
`;
